<div class="booble-backdrop-drawer-right">
  <div class="drawer-rtl-in">
    <div class="drawer-content-lg">
      <div class="row padding-left-32 drawer-header">
        <div class="col-md-11">
          <div class="d-flex flex-column">
            <h2 class="title-modal">Adicionar nova ordem de recebimento</h2>
            <p class="p-text-grey-scale-dark mg-bottom-24">
              Informe os dados abaixo para gerar uma ordem de recebimento
            </p>
          </div>
        </div>

        <div class="col-md-1 d-flex justify-content-end mg-top-10">
          <div (click)="closeModal()" class="close-icon tappable">
            <img src="assets/image/close-modal-icon.svg" />
          </div>
        </div>
      </div>
      <div class="modal-dialog-scrollable-general">
        <div class="modal-body h-100">
          <p class="name">Informações do destinatário do recebimento</p>
          <form [formGroup]="formInfo">
            <div class="row">
              <div class="col-md-12">
                <mat-radio-group
                  class="mg-top-16 mb-3 radios-btns"
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="personType"
                  (change)="onPersonTypeChange($event.value)"
                  aria-label="Selecione uma opção"
                >
                  <mat-radio-button value="PJ">
                    <p class="p-text-grey-scale-dark">Pessoa Jurídica</p>
                  </mat-radio-button>
                  <mat-radio-button value="PF">
                    <p class="p-text-grey-scale-dark">Pessoa Física</p>
                  </mat-radio-button>
                </mat-radio-group>
              </div>

              <ng-container *ngIf="personType === 'PJ'">
                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>CNPJ</mat-label>
                    <mat-select
                      (selectionChange)="changeCompany($event)"
                      formControlName="cnpj"
                      #singleSelect
                    >
                      <mat-option>
                        <ngx-mat-select-search
                          placeholderLabel="CNPJ"
                          noEntriesFoundLabel="Nenhum resultado encontrado"
                          [formControl]="companyListFilterCtrl"
                        ></ngx-mat-select-search>
                      </mat-option>
                      <mat-option
                        *ngFor="let company of filteredCompanyList | async"
                        [value]="company.cnpj"
                      >
                        {{ company.cnpj | mask : "AA.AAA.AAA/AAAA-00" }}
                      </mat-option>
                    </mat-select>
                    <mat-error
                      class="text-danger"
                      *ngIf="
                        formInfo.controls['cnpj'].touched &&
                        formInfo.controls['cnpj'].errors?.required
                      "
                    >
                      CNPJ obrigatório
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Nome do destinatário</mat-label>
                    <input matInput formControlName="companyName" type="text" />
                    <mat-error
                      class="text-danger"
                      *ngIf="
                        formInfo.controls['companyName'].touched &&
                        formInfo.controls['companyName'].errors?.required
                      "
                    >
                      Nome do destinatário obrigatório
                    </mat-error>
                  </mat-form-field>
                </div>
              </ng-container>

              <ng-container *ngIf="personType === 'PF'">
                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>CPF</mat-label>
                    <mat-select
                      (selectionChange)="changePerson($event)"
                      formControlName="cpf"
                      #cpfSelect
                    >
                      <mat-option>
                        <ngx-mat-select-search
                          placeholderLabel="CPF"
                          noEntriesFoundLabel="Nenhum resultado encontrado"
                          [formControl]="personListFilterCtrl"
                        ></ngx-mat-select-search>
                      </mat-option>
                      <mat-option
                        *ngFor="let person of filteredPersonList | async"
                        [value]="person.cpf"
                      >
                        {{ person.cpf | mask : "000.000.000-00" }}
                      </mat-option>
                    </mat-select>
                    <mat-error
                      class="text-danger"
                      *ngIf="
                        formInfo.controls['cpf'].touched &&
                        formInfo.controls['cpf'].errors?.required
                      "
                    >
                      CPF obrigatório
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-md-6">
                  <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Nome do destinatário</mat-label>
                    <input matInput formControlName="name" type="text" />
                    <mat-error
                      class="text-danger"
                      *ngIf="
                        formInfo.controls['name'].touched &&
                        formInfo.controls['name'].errors?.required
                      "
                    >
                      Nome do destinatário obrigatório
                    </mat-error>
                  </mat-form-field>
                </div>
              </ng-container>

              <div class="col-md-12">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Nome do correspondente</mat-label>
                  <input
                    matInput
                    formControlName="businessPartnerName"
                    type="text"
                    class=""
                    name=""
                    required
                  />
                </mat-form-field>
              </div>

              <div class="col-md-6">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Moeda</mat-label>
                  <mat-select formControlName="currency">
                    <mat-option *ngFor="let moeda of moedas" [value]="moeda"
                      ><img
                        [src]="moeda.image"
                        width="20px"
                        height="20px"
                      /><span class="ml-2">{{ moeda.description }}</span>
                    </mat-option>
                    <mat-select-trigger>
                      <mat-icon
                        [svgIcon]="formInfoControls.currency.value.icon"
                      ></mat-icon
                      ><span class="ml-2">{{
                        formInfoControls.currency.value.description
                      }}</span>
                    </mat-select-trigger>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="col-md-6">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Valor recebido</mat-label>
                  <input
                    matInput
                    formControlName="amountReceived"
                    type="text"
                    class=""
                    name=""
                    required
                    currencyMask
                    min="1"
                    [options]="{
                      prefix: currency + ' ',
                      thousands: '.',
                      decimal: ',',
                      align: 'left'
                    }"
                  />

                  <mat-error
                    class="text-danger"
                    *ngIf="
                      formInfo.controls['amountReceived'].touched &&
                      formInfo.controls['amountReceived'].errors?.required
                    "
                  >
                    Valor recebido obrigatório
                  </mat-error>
                  <mat-error
                    class="text-danger"
                    *ngIf="
                      formInfo.controls['amountReceived'].touched &&
                      formInfo.controls['amountReceived'].errors?.min
                    "
                  >
                    O valor recebido não pode ser menor que 1.00.
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <p class="name">Informações do pagamento no exterior</p>

            <div class="row mt-4 form-bank">
              <div class="col-md-6">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Nome do pagador</mat-label>
                  <input
                    matInput
                    formControlName="nameSender"
                    type="text"
                    class=""
                    name=""
                    required
                  />

                  <mat-error
                    class="text-danger"
                    *ngIf="
                      formInfo.controls['nameSender'].touched &&
                      formInfo.controls['nameSender'].errors?.required
                    "
                  >
                    Nome do pagador obrigatório
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="col-md-6">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>País do pagador</mat-label>
                  <mat-select formControlName="countrySenderId">
                    <mat-option
                      *ngFor="let country of countries$ | async"
                      [value]="country.id"
                      >{{ country.description }}</mat-option
                    >
                  </mat-select>
                  <mat-error
                    class="text-danger"
                    *ngIf="
                      formInfo.controls['countrySenderId'].touched &&
                      formInfo.controls['countrySenderId'].errors?.required
                    "
                  >
                    País do pagador obrigatório</mat-error
                  >
                </mat-form-field>
              </div>

              <div class="col-md-6">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Data do recebimento</mat-label>

                  <input
                    matInput
                    formControlName="paymentDate"
                    [matDatepicker]="receiptDatePicker"
                  />

                  <mat-datepicker-toggle matPrefix [for]="receiptDatePicker">
                  </mat-datepicker-toggle>

                  <mat-datepicker #receiptDatePicker [startAt]="startDate">
                  </mat-datepicker>
                </mat-form-field>
              </div>

              <div class="col-md-6">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Banco que recebeu</mat-label>
                  <mat-select formControlName="bankName">
                    <ng-container *ngIf="deme$ | async as banks">
                      <mat-option *ngFor="let bank of banks" [value]="bank">{{
                        bank
                      }}</mat-option>
                    </ng-container>
                  </mat-select>
                  <mat-error
                    class="text-danger"
                    *ngIf="
                      formInfo.controls['bankName'].touched &&
                      formInfo.controls['bankName'].errors?.required
                    "
                  >
                    Banco que recebeu obrigatório</mat-error
                  >
                </mat-form-field>
              </div>

              <div class="col-md-6">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Nº da ordem no exterior</mat-label>
                  <input
                    matInput
                    formControlName="orderNumber"
                    type="text"
                    class=""
                    name=""
                    required
                  />

                  <mat-error
                    class="text-danger"
                    *ngIf="
                      formInfo.controls['orderNumber'].touched &&
                      formInfo.controls['orderNumber'].errors?.required
                    "
                  >
                    Nº da ordem no exterior obrigatório
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="modal-footer-new" [style.justify-content]="'space-between'">
        <button
          type="button"
          [style.width]="'134px'"
          class="btn-outline-dark btn"
          (click)="closeModal()"
          type="button"
        >
          Fechar
        </button>
        <button
          type="button"
          class="btn-footer btn btn-dark-primary-blue"
          [disabled]="formInfo.invalid || loading"
          (click)="sendConfirm()"
          type="button"
        >
          Adicionar
          <span class="spinner-border spinner-border-sm" *ngIf="loading"></span>
        </button>
      </div>
    </div>
  </div>
</div>
